import { render, staticRenderFns } from "./SubMenuItem.vue?vue&type=template&id=6a0b1c00&scoped=true&"
import script from "./SubMenuItem.vue?vue&type=script&lang=ts&"
export * from "./SubMenuItem.vue?vue&type=script&lang=ts&"
import style0 from "./SubMenuItem.vue?vue&type=style&index=0&id=6a0b1c00&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a0b1c00",
  null
  
)

export default component.exports